<template>
  <div id="home">
    <a name="top"></a>
    <section class="banner">
      <img src="../assets/image/banner.png"/>
      <div class="text">
        <div>
          <h2>为企业提供一站式福利解决方案</h2>
          <P>{{url}}</P>
        </div>
      </div>
    </section>
    <section class="value">
      <div class="module-center">
        <h2>企业福利价值</h2>
        <div class="content">
          <ul>
            <li class="lf" v-for="(item, index) in valueArr" :key="index" @mouseleave="liMouseleave" @mouseenter="liMouseenter(index)">
              <div class="bg">{{item.title}}</div>
              <div class="con">
                <div class="lf title">
                  <p>{{item.title}}</p>
                  <img :src="nowVal === index ? item.hImg : item.img"/>
                </div>
                <div class="lf msg">
                  <p v-for="(t, i) in item.text" :key="i">{{t}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="introduce">
      <div class="module-center">
        <h2>企业福利助手简介</h2>
        <div class="content">
          <p>企业福利助手，以大健康为核心，凭借全球领先的IT技术及供应链资源整合能力，实现多场景积分消费，有效促进人力资源转型，为企业提供一站式福利解决方案。</p>
        </div>
      </div>
    </section>
    <section class="reason">
      <div class="module-center">
        <h2>为什么选择企业福利助手</h2>
        <p>连接企业与员工 打造高效福利平台</p>
        <div class="content">
          <img class="lf" src="../assets/image/reason-img.png" alt="企业福利助手"/>
          <ul class="lf">
            <li v-for="(item, index) in reasonArr" :key="index">
              <img class="lf" :src="item.img"/>
              <div class="lf">
                <h4>{{item.title}}</h4>
                <p>{{item.text}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="partner">
      <div class="module-center">
        <div class="tab">
          <ul>
            <li class="lf" :class="[nowTab === i ? 'active' : '']" v-for="(t, i) in tabArr" :key="i">
              <span @mouseover="tabEnter(i)">{{t}}</span>
              <div></div>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <ul>
            <li class="lf" v-for="i in 14" :key="i"><img :src="require('@/assets/image/'+partnerArr[nowTab]+i+'.png')"/></li>
            <li class="lf"><img :src="require('@/assets/image/client15.png')"/></li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      url: this.showUrl,
      valueArr: [
        { title: '企业', text: ['大规模采购价格优势', '企业成本投入减少', '奖励积分协助企业留才', '员工稳定性提升', '提供全面化消费场景', '员工满意度提高'], img: require('../assets/image/val-company.png'), hImg: require('../assets/image/val-company-hover.png') },
        { title: '员工', text: ['定制化员工关怀', '感知企业人性化', '积分抵扣多场景消费', '福利参与度提升', '侧面优化员工收入', '忠诚度大幅度提升'], img: require('../assets/image/val-employee.png'), hImg: require('../assets/image/val-employee-hover.png') },
        { title: '行政', text: ['提供PC端专属管理后台', '一站式服务有条不紊', '整合线上亿级SKU商品', '员工可选性增强', '专属平台智能服务', '解放HR双手'], img: require('../assets/image/val-manage.png'), hImg: require('../assets/image/val-manage-hover.png') }
      ],
      nowVal: -1,
      reasonArr: [
        { title: '灵活积分体系', text: '企业自主充值与发放、积分+现金灵活支付', img: require('../assets/image/reason-score.png') },
        { title: '专业福利管理', text: '全年福利配置及提醒、且福利预算分配顾问', img: require('../assets/image/reason-manage.png') },
        { title: '贴心定制服务', text: '页面功能及价格定制、活动方案及素材定制', img: require('../assets/image/reason-service.png') },
        { title: '全面数据报表', text: '员工偏好数据分析、周期性总结与建议', img: require('../assets/image/reason-report.png') },
      ],
      tabArr: ['我们的客户', '公立医院合作', '供应商合作'],
      nowTab: 0,
      partnerArr: ['client', 'hospital', 'provider']
    }
  },
  methods: {
    liMouseenter(index) {
      this.nowVal = index;
    },
    liMouseleave() {
      this.nowVal = -1;
    },
    tabEnter(i) {
      console.log('over')
      this.nowTab = i;
    }
  },
  components: {
  }
}
</script>
<style scoped lang="less">
  #home {
    .banner {
      height: 455px;
      width: 100%;
      overflow: hidden;
      text-align: center;
      position: relative;
      img {
        height: 455px;
        width: 1920px;
        margin: 0 -100%;
      }
      .text {
        position: absolute;
        z-index: 1;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: left;
        color: @white;
        div {
          width: 1200px;
          height: 100%;
          margin: 0 auto;
          padding-left: 20px;
          box-sizing: border-box;
        }
        h2 {
          font-size:44px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          line-height:62px;
          margin-top: 146px;
        }
        p {
          font-size:24px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          line-height:33px;
          margin-top: 16px;
        }
      }
    }
    .module-center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      &>h2 {
        font-size:30px;
        font-family: @PingFangSC-Semibold;
        font-weight:600;
        color:@text-color;
        line-height:42px;
        text-align: center;
      }
    }
    .value {
      overflow: hidden;
      height: 540px;
      width: 100%;
      .module-center {
        h2 {
          margin-top: 65px;
          margin-bottom: 60px;
        }
        .content {
          ul {
            li {
              width: 365px;
              height: 240px;
              background:rgba(255,255,255,1);
              box-shadow:0px 6px 48px 0px rgba(224,206,173,0.25);
              border-radius:3px;
              margin-right: 50px;
              position: relative;
              cursor: pointer;
              .bg {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                font-size:66px;
                font-family: @PingFangSC-Semibold;
                font-weight:600;
                color:rgba(236,238,237,.3);
                line-height:92px;
              }
              .con {
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                top: 0;
                z-index: 2;
                padding: 30px;
                box-sizing: border-box;
                overflow: hidden;
                .title {
                  margin-right: 60px;
                  p {
                    font-size:22px;
                    font-family:PingFangSC-Semibold;
                    font-weight:600;
                    color:@text-color;
                    line-height:30px;
                    margin-bottom: 16px;
                    text-align: center;
                  }
                  img {
                    height: 92px;
                    width: 92px;
                  }
                }
                .msg {
                  font-size:14px;
                  font-family: @PingFangSC-Regular;
                  font-weight:400;
                  color:@text-color;
                  line-height:20px;
                  p {
                    margin-bottom: 12px;
                  }
                  p:last-child {
                    margin-bottom: none;
                  }
                }
              }
            }
            li:last-child {
              margin-right: 0px;
            }
          }
        }
      }
    }
    .introduce {
      height: 360px;
      width: 100%;
      .module-center {
        background: url('@{image}intro-bg.png') no-repeat center center / 1097px 311px;
        h2 {
          margin-bottom: 140px;
        }
        .content {
          width: 840px;
          margin: 0 auto;
          text-align: center;
          p {
            font-size:18px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            color:rgba(77,77,77,1);
            line-height:40px;
            letter-spacing:2px;
          }
        }
      }
    }
    .reason {
      height: 992px;
      width: 100%;
      background: url('@{image}reason-bg.png') no-repeat center center / 1920px 992px;
      .module-center {
        padding-top: 145px;
        h2 {
          margin-bottom: 10px;
        }
        &>P {
          font-size:18px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          color:@text-color;
          line-height:25px;
          text-align: center;
        }
        .content {
          margin-top: 35px;
          overflow: hidden;
          &>img {
            width: 605px;
            height: 672px;
            margin-right: 87px;
            margin-left: 17px;
          }
          &>ul {
            padding-top: 58px;
            li {
              overflow: hidden;
              margin-bottom: 62px;
              img {
                height: 78px;
                width: 78px;
              }
              div {
                color:@text-color;
                margin-left: 30px;
                h4 {
                  font-size:22px;
                  font-family: @PingFangSC-Semibold;
                  font-weight:600;
                  line-height:30px;
                  margin-top: 8px;
                }
                p {
                  font-size:18px;
                  font-family: @PingFangSC-Regular;
                  font-weight:400;
                  line-height:25px;
                  margin-top: 8px;
                }
              }
            }
          }
        }
      }
    }
    .partner {
      height: 636px;
      width: 100%;
      overflow: hidden;
      .module-center {
        margin-top: 110px;
        .tab {
          ul {
            overflow: hidden;
            li {
              margin-right: 105px;
              cursor: pointer;
              span {
                font-size:30px;
                font-family:@PingFangSC-Regular;
                font-weight:400;
                color:rgba(70,70,70,1);
                line-height:42px;
              }
              div {
                text-align: center;
              }
            }
            li:first-child {
              margin-left: 305px;
            }
            li:last-child {
              margin-right: 0px;
            }
            .active {
              span {
                font-family: @PingFangSC-Semibold;
                font-weight:600;
                color:rgba(255,173,2,1);
              }
              div {
                &::after {
                  content: '';
                  display: inline-block;
                  width:108px;
                  height:4px;
                  background:rgba(255,173,2,1);
                  border-radius:1px;
                  margin-top: 3px;
                }
              }
            }
          }
        }
        .tab-content {
          margin-top: 53px;
          ul {
            overflow: hidden;
            li {
              margin: 0px 17px 60px 17px;
              img {
                width: 205px;
                height: 68px;
              }
            }
          }
        }
      }
    }
  }
</style>
